import React, { useState, useMemo, useCallback } from 'react';
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { Card } from "react-bootstrap";
import BankApprovalPopup from './BankApprovalPopup';

const DATE_FORMATTER = new Intl.DateTimeFormat('en-US', {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
});

const PendingRequests = ({ data, totalCount, refetch }) => {
    const [selectedRequest, setSelectedRequest] = useState(null);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
        filter: true,
        flex: 1,
        // minWidth: 150,
        suppressMovable: true,
    }), []);

    const frameworkComponents = useMemo(() => ({
        actionCellRenderer: (params) => (
            <button
                className="docg-save-btn"
                style={{ padding: "0px 12px", borderRadius: "24px" }}
                onClick={() => setSelectedRequest(params.data)}
            >
                Approve
            </button>
        )
    }), []);

    return (
        <>
            <Card className="docg-card">
                <Card.Header className="customCardHeader d-flex justify-content-between">
                    <Card.Title className="customCardTitle">
                        Bank Details Approval Requests
                        {typeof totalCount === "number"
                            ? ` (${data?.length ?? 0} of ${totalCount})`
                            : data?.length
                                ? ` (${data.length})`
                                : ""}
                    </Card.Title>
                    <button onClick={refetch} className="docg-save-btn">Refresh</button>
                </Card.Header>
                <Card.Body className="p-0">
                    <div className="ag-theme-alpine" style={{ height: "100%", minHeight: "200px", width: "100%" }}>
                        <AgGridReact
                            rowData={data}
                            defaultColDef={defaultColDef}
                            rowHeight={60}
                            frameworkComponents={frameworkComponents}
                            pagination={true}
                            paginationPageSize={10}
                            animateRows={true}
                            overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">No pending requests</span>'}
                        >
                            <AgGridColumn headerName="Clinic Name" field="clinicName" tooltipField="clinicName" />
                            <AgGridColumn headerName="Beneficiary" field="beneficiaryName" />
                            <AgGridColumn
                                headerName="Request Date"
                                field="createdAt"
                                valueFormatter={(params) => params.value ? DATE_FORMATTER.format(new Date(params.value)) : "-"}
                            />
                            <AgGridColumn headerName="Account No" field="bankAccountNumber" />
                            <AgGridColumn headerName="IFSC Code" field="ifscCode" />
                            <AgGridColumn headerName="Action" cellRenderer="actionCellRenderer" />
                            <AgGridColumn headerName="Status" field="status" />
                        </AgGridReact>
                    </div>
                </Card.Body>
            </Card>

            <BankApprovalPopup
                approvalPopup={!!selectedRequest}
                clinicId={selectedRequest?.clinicId}
                closeApprovalPopup={() => setSelectedRequest(null)}
                refetch={refetch}
            />
        </>
    );
};

export default PendingRequests;